import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Card.module.css';

export type CardVariant = 'default' | 'raised' | 'veil' | 'accent';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  /** Set false to opt out of the default padding, e.g. when a card wraps a
   *  full-bleed table of rows (as in the measurements panel). */
  padded?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'default', padded = true, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(
        styles.card,
        variant !== 'default' && styles[variant],
        padded && styles.padded,
        rest.onClick && styles.interactive,
        className,
      )}
      {...rest}
    />
  );
});
